<div class="search-container">
  <h4>{{ formatLabel(data?.title) }}<span class="dvm-mandatory-mark" *ngIf="isMandatory" aria-hidden="true">*</span></h4>

  <mat-form-field appearance="outline" class="search-form-field">
    <mat-label>{{ formatLabel(data?.placeholder) }}</mat-label>
    <mat-icon matPrefix>search</mat-icon>

    <input 
  matInput
  type="text"
  [(ngModel)]="searchTerm"
  (keydown.enter)="$event.preventDefault()"   
  (keyup.enter)="emitSearch($event)"           
  (blur)="emitSearch()"
  (input)="onTyping()"
/>




    <button mat-icon-button matSuffix *ngIf="searchTerm" (click)="clearSearch()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-form-field>
</div>
